import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from 'react';
import styles from './SegmentedText.module.scss';
export function SegmentedText(param) {
    let { segments, unresolvedTestId } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: segments.map((segment, index)=>segment.kind === 'text' ? /*#__PURE__*/ _jsx(Fragment, {
                children: segment.value
            }, index) : /*#__PURE__*/ _jsx("span", {
                className: styles.unresolved,
                "data-testid": unresolvedTestId(segment.label),
                children: "{{".concat(segment.label, "}}")
            }, index))
    });
}
